<template>
  <DialogBase
    title="Sửa thông tin lớp học"
    :visible.sync="dialogVisible"
    size="sm"
    panel-icon="el-icon-edit"
    panel-title="Thông tin lớp"
    panel-subtitle="Chỉnh sửa thông tin lớp học"
    :confirm-loading="loadingButton"
    :confirm-disabled="!showSaveChange"
    confirm-text="Lưu"
    confirm-type="primary"
    cancel-text="Hủy"
    cancel-type=""
    cancel-icon=""
    confirm-icon=""
    @before-close="handleClose"
    @cancel="handleClose"
    @confirm="handleSave"
  >
    <el-form
      ref="dataForm"
      :model="editClass"
      :rules="formRules"
      label-position="top"
    >
      <!-- Khối học (readonly) -->
      <el-form-item label="Khối học">
        <el-input
          disabled
          :value="editClass.grade ? editClass.grade.gradeName : ''"
        />
      </el-form-item>

      <el-form-item label="Tên lớp" prop="className">
        <el-input
          v-model="editClass.className"
          placeholder="Nhập tên lớp"
          @keyup.enter.native="handleSave"
        />
        <span v-if="customErrorMessages.newNameKt" class="sk-note sk-note--danger sk-u-mt-12">
          <i class="el-icon-warning-outline" />
          <span>{{ customErrorMessages.newNameKt }}</span>
        </span>
      </el-form-item>

      <el-form-item label="Mô tả" prop="classDescription" class="sk-u-mt-12">
        <el-input
          v-model="editClass.classDescription"
          type="textarea"
          :rows="1"
          autosize
          placeholder="Nhập mô tả"
        />
      </el-form-item>
    </el-form>
  </DialogBase>
</template>

<script>
import DialogBase from "@/components/DialogBase.vue";
import MaClassService from "@/services/MaClassService";
import financeKidsV2Service from "@/services/Finance_Kids_V2/FinanceKidsV2Service";

export default {
  components: { DialogBase },
  props: {
    dialogVisible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      editClass: {
        id: "",
        className: "",
        classDescription: "",
        grade: {},
      },
      classList: [],
      className: "",
      customErrorMessages: {
        newNameKt: "",
      },
      showSaveChange: false,
      gradeList: [],
      editClassCreated: null,
      loadingButton: false,
      formRules: {
        className: [
          {
            validator: this.changeClassName,
            trigger: "change",
          },
        ],
      },
    };
  },
  methods: {
    handleClose(done) {
      this.showSaveChange = false;
      this.customErrorMessages.newNameKt = "";
      this.$emit("dialog-close");
      this.$nextTick(() => {
        if (this.$refs.dataForm) {
          this.$refs.dataForm.resetFields();
        }
      });
      if (typeof done === "function") done();
    },

    handleSave() {
      this.$refs.dataForm.validate((valid) => {
        if (valid) {
          this.loadingButton = true;
          MaClassService.update(this.editClass)
            .then((response) => {
              this.editClassCreated = response.data.data;
              this.$message({
                message: "Cập nhật lớp thành công",
                type: "success",
              });
              this.handleClose();
            })
            .catch((err) => {
              this.$message({
                message: err.response.data.message,
                type: "error",
              });
            })
            .finally(() => {
              this.loadingButton = false;
            });
        }
      });
    },

    async getClassByIdMethod(idClass) {
      await MaClassService.findClassNewById(idClass)
        .then((resp) => {
          this.editClass = resp.data.data;
          this.className = this.editClass.className;
        })
        .catch((err) => {
          console.log(err);
        });

      await financeKidsV2Service
        .getClassInGrade(parseInt(this.editClass.grade.id))
        .then((resp) => {
          resp.data && resp.data.data
            ? (this.classList = resp.data.data)
            : (this.classList = []);
        })
        .catch((err) => {
          console.log(err);
        });
    },

    getDataInitial(idClass) {
      this.getClassByIdMethod(idClass);
    },

    changeClassName(rule, value, callback) {
      let index = -1;
      if (this.classList.length !== 0) {
        for (let i = 0; i < this.classList.length; i++) {
          if (this.className === this.classList[i].className) {
            index = i;
          }
        }
        if (index > -1) {
          this.classList.splice(index, 1);
        }
        for (let i = 0; i < this.classList.length; i++) {
          if (!value) {
            this.customErrorMessages.newNameKt =
              "Giá trị không được để trống!";
            this.showSaveChange = false;
            break;
          } else if (
            value.replace(/\s/g, "") === this.className.replace(/\s/g, "")
          ) {
            this.customErrorMessages.newNameKt =
              "Tên lớp không có sự thay đổi!";
            this.showSaveChange = false;
            break;
          } else if (
            value.toLowerCase().replace(/\s/g, "") ===
            this.classList[i].className.toLowerCase().replace(/\s/g, "")
          ) {
            this.customErrorMessages.newNameKt =
              "Tên lớp: " +
              this.classList[i].className +
              " đã tồn tại trong khối!";
            this.showSaveChange = false;
            break;
          } else {
            this.showSaveChange = true;
            this.customErrorMessages.newNameKt = "";
            callback();
          }
        }
      } else {
        this.showSaveChange = true;
        this.customErrorMessages.newNameKt = "";
        callback();
      }
    },
  },
};
</script>

<style scoped lang="scss">
@import "@/assets/style/sk-dialog";
</style>
